import { IPlayer, IPlayerFinance } from '../../api/players'

export type PlayerFinancialHistoryProps = Pick<IPlayer, 'id' | 'login' | 'currency'>

export enum EFinanceReason {
  ROLLBACK = 'rollback',
  DROP = 'drop',
  CREDIT = 'credit',
  GIFT = 'gift',
  SETTLE = 'settle',
  OPENING_BALANCE = 'opening_balance',
}

export const FINANCE_REASON_LABELS: Record<EFinanceReason, string> = {
  [EFinanceReason.ROLLBACK]: 'Откат',
  [EFinanceReason.DROP]: 'Дроп',
  [EFinanceReason.CREDIT]: 'Пополнение',
  [EFinanceReason.GIFT]: 'Подарок',
  [EFinanceReason.SETTLE]: 'Результат игры',
  [EFinanceReason.OPENING_BALANCE]: 'Открытие счета',
}

export interface IFinanceQuery {
  from?: string
  to?: string
  reasons?: string[]
  limit: number
  offset: number
}

export interface IFinanceData {
  rows: IPlayerFinance[]
  total: number
  amounts: number
}
